module.exports = __webpack_public_path__ + "img/image4.595493b9.png";